import request from './request'
export const psdChangeMixin = {
    methods: {

        async  createRules(data = {}) {

            const res = await request({
                data: {
                    header: {
                        "serviceCode": "PASSWORWD_RULE",
                        "method": "getRule"
                    },
                    body: {
                        ...data
                    }
                },
                notLoading: true
            });

            const rule = Object.assign({}, { englishLetter: true, number: true, specialLetter: true, length: 14 }, res.data.body.data || {});
            let ruleLast = [], msg = [];
            const englishLetter = this.joinReg(rule.englishLetter, '(?![A-Za-z]*$)', ruleLast, 'a-zA-Z', msg, '字母')
            const number = this.joinReg(rule.number, '(?![0-9]*$)', ruleLast, '0-9', msg, '数字');
            const specialLetter = this.joinReg(rule.specialLetter, '(?![!"\\$%\\&\'\\(\\)\\*\\+,-\\.\\/:;<=>\?@ \\[#\\,\\]\\^ _`\\{ \\|\\}~])', ruleLast, '!"\\$%\\&\'\\(\\)\\*\\+,-\\.\\/:;<=>\?@ \\[#\\,\\]\\^ _`\\{ \\|\\}~', msg, '特殊字符', );
            const reg = englishLetter + number + specialLetter + '[' + ruleLast.join('') + ']' + '{' + rule.length + '}'
            const length = rule.length;
            const regs = new RegExp(reg, 'i');

            return { regs, length, msg }
        },
        joinReg(flag, params, arr, last, msg, message) {
            if (flag) {
                arr.push(last);
                msg.push(message)
                return params
            }
            return ''
        },
        async resetPassword(body) {
            const res = await request({
                data: {
                    header: {
                        serviceCode: "MEMBER_CHANGE_PASSOWRD",
                        method: "change"
                    },
                    body: {
                        ...body
                    }
                }
            });
            const code=res.data.header.returnCode;
            const loginMsg = this.checkStatus(code);
            loginMsg && this.$message.error(loginMsg);
            return {code}

        },
        checkStatus(code) {
            switch (code) {
                case "20000": return '密码需要重置';
                case "20001": return '密码错误';
                case "20002": return "验证码错误";
                case "20003": return "密码过期,需要重置";
                case "20004": return "新旧密码一致,请重新设置";
                case "30000": return "用户不存在";
                case "000000": return '';
                default: return '执行失败'
            }
        }
    }
}


// WEBPACK FOOTER //
// ./src/utils/passwordChangeMixin.js